export default __webpack_public_path__ + "static/media/panda_commerce_bootstrap.ab003c02.png";